module.exports = __webpack_public_path__ + "img/logo.4bee3861.png";